import component from './PhHeart.vue_vue_type_script_lang.vue.js';
export { default } from './PhHeart.vue_vue_type_script_lang.vue.js';
import { render } from './PhHeart.vue_vue_type_template_id_005ae62d_lang.vue.js';

component.render = render;
